import styled from '@emotion/styled';
import { FilterContainer } from '../../style';

export const Container = styled(FilterContainer)`
  justify-content: space-between;
  align-items: center;
  min-width: 160px;
  max-width: 200px;
`;
